<template>
    <div class="address-wrap">
        <div class="title">
        收货地址
        <!-- {{propId}}; {{chosedId}} -->
        <div class="rightBtn">
            <button class="cg-btn" @click="addAddressHandle">新增</button>
            <!-- <button class="cg-btn" @click="editAddressHandle">编辑11</button> -->
        </div>
        </div>
        <div class="no-address-list" v-if="addressList.length == 0">
            暂无地址列表
        </div>
        <div class="address-list" v-else>
            <div class="address-item" :class="{active:chosedId==item.address_id}" v-for="item in addressList" :key="item.address_id" 
            @click="choseAddress(item)">
                <div class="block-item clearfix">
                    <div class="span-item">
                        <span class="label">姓名:</span>
                        <span class="text">{{item.address_contact_name}}</span>
                    </div>
                    <div class="span-item">
                        <span class="label">手机号:</span>
                        <span class="text">{{item.address_contact_phone}}</span>
                        <span class="default" v-if="item.address_is_default == 'y'">默认</span>
                    </div>
                </div>
                <div class="block-item">
                    <span class="label">地址:</span>
                    <span class="text">
                        {{item.region_province_string}}
                        {{item.region_city_string}}
                        {{item.region_district_string}}
                        {{item.address_string}}
                    </span>
                </div>
                <!-- <button @click="addAddressHandle(item)">测试</button> -->
                <div class="edit">
                    <img src="../../../assets/common_icon_xiugai.png" alt="" class="icon" @click="editAddressHandle(item)">
                </div>
            </div>
        </div>
        <el-dialog
            title="新增地址"
            :visible.sync="addAddressDialogVisible"
            width="760px"
            :close-on-click-modal="false" append-to-body
        >
            <div class="add-address-wrap">
                <el-form
                    :model="addAddressForm"
                    :rules="addAddressFormRules"
                    ref="addAddressForm"
                    label-width="100px"
                >
                    <el-form-item prop="addressContactName" size="small" label="姓名">
                        <el-input type="text" v-model.trim="addAddressForm.addressContactName"
                            placeholder="请输入您的姓名"
                        ></el-input>
                    </el-form-item>
                    <el-form-item prop="addressContactPhone" size="small" label="手机号">
                        <el-input type="text" v-model.trim="addAddressForm.addressContactPhone"
                            placeholder="请输入您的手机号"
                        ></el-input>
                    </el-form-item>
                    <el-form-item size="small" label="省市区" required>
                        <el-col :span="8">
                            <el-form-item prop="regionProvince">
                                <el-select size="mini" v-model="addAddressForm.regionProvince" style="width: 94%"
                                    value-key="region_id" placeholder="请选择" @change="selectArea(1)">
                                    <el-option :label="item.region_name" :value="item" v-for="item in provinceList" :key="item.region_id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="cityList.length>0">
                            <el-form-item prop="regionCity">
                                <el-select size="mini" v-model="addAddressForm.regionCity" style="width: 94%"
                                    value-key="region_id" placeholder="请选择" @change="selectArea(2)">
                                    <el-option :label="item.region_name" :value="item" v-for="item in cityList" :key="item.region_id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8"  v-if="districtList.length>0">
                            <el-form-item prop="regionDistrict">
                                <el-select size="mini" v-model="addAddressForm.regionDistrict"
                                    value-key="region_id" placeholder="请选择">
                                    <el-option :label="item.region_name" :value="item" v-for="item in districtList" :key="item.region_id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                    <el-form-item prop="addressString" size="small" label="详细地址">
                        <el-input type="textarea" v-model.trim="addAddressForm.addressString"
                            placeholder="请输入详细地址"
                        ></el-input>
                    </el-form-item>
                    <el-form-item prop="addressIsDefault" label="设为默认">
                        <el-switch v-model="addAddressForm.addressIsDefault"></el-switch>
                    </el-form-item>
                    <el-form-item label="">
                        <button class="cg-btn" type="button" @click="addAddressDialogVisible = false">取消</button>
                        <button class="cg-btn red mgl-16" type="button" @click="submitAddAddressForm">确定</button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>

        <el-dialog
            title="编辑地址"
            :visible.sync="editAddressDialogVisible"
            width="760px"
            :close-on-click-modal="false" append-to-body
        >
            <div class="add-address-wrap">
                <el-form
                    :model="editAddressForm"
                    :rules="editAddressFormRules"
                    ref="editAddressForm"
                    label-width="100px"
                >
                    <el-form-item prop="addressContactName" size="small" label="姓名">
                        <el-input type="text" v-model.trim="editAddressForm.addressContactName"
                            placeholder="请输入您的姓名"
                        ></el-input>
                    </el-form-item>
                    <el-form-item prop="addressContactPhone" size="small" label="手机号">
                        <el-input type="text" v-model.trim="editAddressForm.addressContactPhone"
                            placeholder="请输入您的手机号"
                        ></el-input>
                    </el-form-item>
                    <el-form-item size="small" label="省市区" required>
                        <el-col :span="8">
                            <el-form-item prop="regionProvince">
                                <el-select size="mini" v-model="editAddressForm.regionProvince" style="width: 94%"
                                    value-key="region_id" placeholder="请选择" @change="selectArea2(1)">
                                    <el-option :label="item.region_name" :value="item" v-for="item in provinceList2" :key="item.region_id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="cityList2.length>0">
                            <el-form-item prop="regionCity">
                                <el-select size="small" v-model="editAddressForm.regionCity" style="width: 94%"
                                    value-key="region_id" placeholder="请选择" @change="selectArea2(2)">
                                    <el-option :label="item.region_name" :value="item" v-for="item in cityList2" :key="item.region_id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="districtList2.length>0">
                            <el-form-item prop="regionDistrict">
                                <el-select size="small" v-model="editAddressForm.regionDistrict" style="width: 100%"
                                    value-key="region_id" placeholder="请选择">
                                    <el-option :label="item.region_name" :value="item" v-for="item in districtList2" :key="item.region_id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        
                        
                    </el-form-item>
                    <el-form-item prop="addressString" size="small" label="详细地址">
                        <el-input type="textarea" v-model.trim="editAddressForm.addressString"
                            placeholder="请输入详细地址"
                        ></el-input>
                    </el-form-item>
                    <el-form-item prop="addressIsDefault" label="设为默认">
                        <el-switch v-model="editAddressForm.addressIsDefault"></el-switch>
                    </el-form-item>
                    <el-form-item label="">
                        <button class="cg-btn" type="button" @click="editAddressDialogVisible = false">取消</button>
                        <button class="cg-btn red mgl-16" type="button" @click="submitEditAddressForm">确定</button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { requestUserAddressList, regionInfo, addUserAddress, updateAddressByAddressId } from '../../../api/address'
import { validateMobile } from '../../../utils/validate'
import { mapGetters } from 'vuex'
export default {
    props:['propId'],
    data() {
        var validatePhone =  (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入手机号'))
            } else if (!validateMobile(value)){
                callback(new Error('手机号格式不正确'))
            } else {
                callback()
            }
        }
        return {
            // 地址相关
            addressList: [],
            chosedId:'',
            // 新增地址
            provinceList: [],
            cityList: [],
            districtList: [],
            addAddressDialogVisible: false,
            addAddressForm: {
                regionProvince: '',
                regionCity: '',
                regionDistrict: '',
                addressString: '',
                addressContactName: '',
                addressContactPhone: '',
                addressIsDefault: false
            },
            addAddressFormRules: {
                addressContactName: [
                    { required: true, message: "请输入姓名", trigger: 'change' }
                ],
                addressContactPhone: [
                    { required: true, validator: validatePhone, trigger: 'change' }
                ],
                regionProvince: [
                    { required: true, message: "请选择", trigger: 'change' }
                ],
                regionCity: [
                    { required: true, message: "请选择", trigger: 'change' }
                ],
                regionDistrict: [
                    { required: true, message: "请选择", trigger: 'change' }
                ],
                addressString: [
                    { required: true, message: "请输入详细地址", trigger: 'change' }
                ],
            },

            // 编辑地址
            provinceList2: [],
            cityList2: [],
            districtList2: [],
            editAddressDialogVisible: false,
            editAddressForm: {
                addressId: '',
                regionProvince: '',
                regionCity: '',
                regionDistrict: '',
                addressString: '',
                addressContactName: '',
                addressContactPhone: '',
                addressIsDefault: false
            },
            editAddressFormRules: {
                addressContactName: [
                    { required: true, message: "请输入姓名", trigger: 'change' }
                ],
                addressContactPhone: [
                    { required: true, validator: validatePhone, trigger: 'change' }
                ],
                regionProvince: [
                    { required: true, message: "请选择", trigger: 'change' }
                ],
                regionCity: [
                    { required: true, message: "请选择", trigger: 'change' }
                ],
                regionDistrict: [
                    { required: true, message: "请选择", trigger: 'change' }
                ],
                addressString: [
                    { required: true, message: "请输入详细地址", trigger: 'change' }
                ],
            }


        }
    },
    computed: {
        ...mapGetters(['userId']),
        // chosedId(){
        //     return this.propId
        // },
    },
    created() {
        this.requestUserAddressListFun()
        this.chosedId=this.propId
    },
    methods: {
        choseAddress(item){
          //选择地址
          this.chosedId=item.address_id
          this.$emit('chose',item)
        },
        // 收货地址
        requestUserAddressListFun () {
            requestUserAddressList({
                userId: this.userId
            }).then(res => {
                console.log(res)
                if (res.errorCode == 200) {
                    this.addressList = res.data
                } else if (res.errorCode == -10005) {
                    // 暂无地址
                    this.addressList = []
                } else {
                    this.$message.error(res.errorMsg || '获取地址列表失败')
                }
            }).catch(err => {
                console.log(err)
            })
        },
        regionInfo(type, id, handleType, active) {  // type ： 1 省 2 市 3 区    handleType: add edit
            regionInfo({
                parentId: id
            }).then(res => {
                console.log(res)
                if (res.errorCode == 200) {
                    if (handleType == 'add') {
                        if (type == 1) {
                            this.provinceList = res.data || []
                            this.cityList = []
                        }
                        if (type == 2) {
                            this.cityList = res.data || []
                            this.districtList = []
                        }
                        if (type == 3) {
                            this.districtList = res.data || []
                        }
                    }
                    if (handleType == 'edit') {
                        if (type == 1) {
                            this.provinceList2 = res.data || []
                            this.cityList2 = []
                            if (active) {
                                if (this.editAddressForm.regionProvince.region_id) {
                                    this.regionInfo(2, this.editAddressForm.regionProvince.region_id, 'edit', true)
                                } else {
                                    let filter = this.provinceList2.filter(item => item.region_name == this.editAddressForm.regionProvince.region_name)
                                    console.log(filter)
                                    if (filter.length > 0) {
                                        this.editAddressForm.regionProvince = filter[0]
                                        this.regionInfo(2, this.editAddressForm.regionProvince.region_id, 'edit', true)
                                    }
                                }
                            }
                        }
                        if (type == 2) {
                            this.cityList2 = res.data || []
                            this.districtList2 = []
                            if (active) {
                                if (this.editAddressForm.regionCity.region_id) {
                                    this.regionInfo(3, this.editAddressForm.regionCity.region_id, 'edit', true)
                                } else {
                                    let filter = this.cityList2.filter(item => item.region_name == this.editAddressForm.regionCity.region_name)
                                    console.log(filter)
                                    if (filter.length > 0) {
                                        this.editAddressForm.regionCity = filter[0]
                                        this.regionInfo(3, this.editAddressForm.regionCity.region_id, 'edit', true)
                                    }
                                }
                            }
                            
                        }
                        if (type == 3) {
                            this.districtList2 = res.data || []
                            if (active) {
                                if (!this.editAddressForm.regionDistrict.region_id) {
                                    let filter = this.districtList2.filter(item => item.region_name == this.editAddressForm.regionDistrict.region_name)
                                    console.log(filter)
                                    if (filter.length > 0) {
                                        this.editAddressForm.regionDistrict = filter[0]
                                    }
                                }
                            }
                        }
                    }
                }
            }).catch(err => {
                console.log(err)
            })
        },
        addAddressHandle() {
            this.addAddressDialogVisible = true
            if (this.provinceList.length == 0) {
                this.regionInfo(1, '0', 'add')
            }
        },
        editAddressHandle(obj) {
            this.editAddressDialogVisible = true
            this.editAddressForm = {
                addressId: obj.address_id,
                regionProvince: {
                    region_name: obj.region_province_string,
                    region_id: obj.company_province_id
                },
                regionCity: {
                    region_name: obj.region_city_string,
                    region_id: obj.company_city_id
                },
                regionDistrict: {
                    region_name: obj.region_district_string,
                    region_id: obj.company_district_id
                },
                addressString: obj.address_string,
                addressContactName: obj.address_contact_name,
                addressContactPhone: obj.address_contact_phone,
                addressIsDefault: obj.address_is_default == 'y' ? true : false
            }
            this.regionInfo(1, '0', 'edit', true)
        },
        selectArea(type) {
            console.log('selectArea', type)
            if (type == 1) { // 选择省
                this.regionInfo(2, this.addAddressForm.regionProvince.region_id, 'add')
                this.addAddressForm.regionCity = ''
                this.addAddressForm.regionDistrict = ''
            }
            if (type == 2) { // 选择市
                this.regionInfo(3, this.addAddressForm.regionCity.region_id, 'add')
                this.addAddressForm.regionDistrict = ''
            }
        },
        selectArea2(type) {
            console.log('selectArea', type)
            if (type == 1) { // 选择省
                this.regionInfo(2, this.editAddressForm.regionProvince.region_id, 'edit')
                this.editAddressForm.regionCity = ''
                this.editAddressForm.regionDistrict = ''
            }
            if (type == 2) { // 选择市
                this.regionInfo(3, this.editAddressForm.regionCity.region_id, 'edit')
                this.editAddressForm.regionDistrict = ''
            }
        },
        submitAddAddressForm () {
            this.$refs['addAddressForm'].validate((valid) => {
                if (valid) {
                    addUserAddress({
                        regionProvinceId: this.addAddressForm.regionProvince.region_id,
                        regionProvinceString: this.addAddressForm.regionProvince.region_name,
                        regionCityId: this.addAddressForm.regionCity.region_id,
                        regionCityString: this.addAddressForm.regionCity.region_name,
                        regionDistrictId: this.addAddressForm.regionDistrict.region_id,
                        regionDistrictString: this.addAddressForm.regionDistrict.region_name,
                        addressString: this.addAddressForm.addressString,
                        addressContactName: this.addAddressForm.addressContactName,
                        addressContactPhone: this.addAddressForm.addressContactPhone,
                        addressIsDefault: this.addAddressForm.addressIsDefault ? 'y' : 'n',
                        userId: this.userId
                    }).then(res => {
                        console.log(res)
                        if (res.errorCode == 200) {
                            this.$message.success('新增地址成功')
                            this.$refs['addAddressForm'].resetFields()
                            this.cityList = []
                            this.districtList = []
                            this.addAddressDialogVisible = false
                            this.requestUserAddressListFun()
                        } else {
                            this.$message.error(res.errorMsg || '新增地址失败')
                        }
                    }).catch(err => {
                        console.log(err)
                    })
                }
            })
        },
        submitEditAddressForm () {
            this.$refs['editAddressForm'].validate((valid) => {
                if (valid) {
                    updateAddressByAddressId({
                        addressId: this.editAddressForm.addressId,
                        regionProvinceId: this.editAddressForm.regionProvince.region_id,
                        regionProvinceString: this.editAddressForm.regionProvince.region_name,
                        regionCityId: this.editAddressForm.regionCity.region_id,
                        regionCityString: this.editAddressForm.regionCity.region_name,
                        regionDistrictId: this.editAddressForm.regionDistrict.region_id,
                        regionDistrictString: this.editAddressForm.regionDistrict.region_name,
                        addressString: this.editAddressForm.addressString,
                        addressContactName: this.editAddressForm.addressContactName,
                        addressContactPhone: this.editAddressForm.addressContactPhone,
                        addressIsDefault: this.editAddressForm.addressIsDefault ? 'y' : 'n',
                        userId: this.userId
                    }).then(res => {
                        console.log(res)
                        if (res.errorCode == 200) {
                            this.$message.success('编辑地址成功')
                            this.$refs['editAddressForm'].resetFields()
                            this.cityList2 = []
                            this.districtList2 = []
                            this.editAddressDialogVisible = false
                            this.requestUserAddressListFun()
                        } else {
                            this.$message.error(res.errorMsg || '编辑地址失败')
                        }
                    }).catch(err => {
                        console.log(err)
                    })
                }
            })
        }

    },
}
</script>

<style lang="scss" scoped>
.address-wrap {
    .title{
        height: 64px;line-height: 64px;font-size: 16px;opacity:0.85;font-weight: bold; position: relative;
        .icon{width: 15px;height: 15px; margin-left:14px; vertical-align: middle;}
        .rightBtn{position: absolute;top:0;right:24px;
            button{width: 44px;height: 24px;padding:0;border-radius: 2px;}
        }
    }
}
.no-address-list {
    color: rgba(0, 0, 0, 0.85);
}


//普通样式
.address-list {
    
    .address-item:last-child{border-bottom: 0;}
    .address-item {
        position: relative;
        padding: 15px 0px;
        border-bottom:  0.5px dotted #e6e6e6;
        &:first-child {
            padding-top: 0;
        }
        .edit {
            position: absolute;
            right: 40px;
            top: 25px;
        }
        .icon {
            width: 15px;
            height: 15px;
            cursor: pointer;
        }
    }
    
    .block-item {
        display: block;
        margin-bottom: 4px;
    }
    .span-item {
        float: left;
        width: 33.3%;
    }
    .default {
        // background: #999;
        background: #F81D22;
        color: #fff;
        padding: 0 10px;
        margin-left: 32px;
    }
    .label {
        color: rgba(0, 0, 0, 0.85); margin-right: 6px;
    }
    .text {
        color: rgba(0, 0, 0, 0.65);
    }
}
// 在锁仓等页面里面的样式
.addressAllModalWrap .address-list {
    .address-item{padding-left:20px; cursor: pointer;border-radius: 10px;padding-top:20px}
    .address-item:hover{border:1px solid #fff;  
        // box-shadow:0 0px 5px rgba(255,100,100,0.7);
    }
    .address-item.active{border:1px solid rgba(255,100,100,1); }
    .address-item:first-child{padding-top:20px}
} 
</style>